import * as R from 'ramda';

export const orderAscendingNullAtEnd = R.cond([
  [R.and(R.compose(R.isNil, R.nthArg(0)), R.compose(R.isNil, R.nthArg(1))), R.always(-1)],
  [R.and(R.compose(R.isNil, R.nthArg(1)), R.compose(R.isNil, R.nthArg(0))), R.always(1)],
  [R.T, R.converge(R.add, [R.nthArg(0), R.compose(R.negate, R.nthArg(1))])],
]);
